module.exports = __webpack_public_path__ + "static/media/down.23c6ad87.png";